export default __webpack_public_path__ + "2da51887cda938bcf883ce2a5a6c0985.pdf";